// src/Routes.js
import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import Loader from "./Components/Common/Loader";
import UnderConstruction from "./Pages/UnderContruction";
import PdfJson from "./PdfJson/PdfJson";
import Excel from "./Excel/Excel";
import EmployeeMatrixPage from "./Pages/Dashbaord/Employee/EmployeeMatrixPage";
import EmployeeDocument from "./Pages/Dashbaord/Employee/EmployeeDocument";
import EmployeeDocumentView from "./Pages/Dashbaord/Employee/EmployeeDocumentView";

// Lazy load components
const Login = lazy(() => import("./Pages/Login"));
const Logout = lazy(() => import("./Pages/Logout"));
const ApplyOnline = lazy(() => import("./Pages/ApplyOnline"));
const ApplyOnlineLayout = lazy(
  () => import("./Pages/ApplyOnlineForms/ApplyOnlineLayout"),
);
const Form1Form = lazy(() => import("./Components/ApplyOnline/Form1Form"));
const Form2Form = lazy(() => import("./Components/ApplyOnline/Form2Form"));
const Form3Form = lazy(() => import("./Components/ApplyOnline/Form3Form"));
const Form4Form = lazy(() => import("./Components/ApplyOnline/Form4Form"));
const Form10Form = lazy(() => import("./Components/ApplyOnline/Form10Form"));
const Form11Form = lazy(() => import("./Components/ApplyOnline/Form11Form"));
const FinishForm = lazy(() => import("./Components/ApplyOnline/FinishForm"));
const UploadDocumentsForm = lazy(
  () => import("./Components/ApplyOnline/UploadDocumentsForm"),
);
const GdprNoticeForm = lazy(
  () => import("./Components/ApplyOnline/GdprNoticeForm"),
);
const Form9Form = lazy(() => import("./Components/ApplyOnline/Form9Form"));

const ApplySubcontractor = lazy(() => import("./Pages/ApplySubcontractor"));
const DashboardHome = lazy(() => import("./Pages/Dashbaord/Home"));
const DashboardLayout = lazy(
  () => import("./Components/Dashboard/DashboardLayout"),
);
const EmployeeOperations = lazy(
  () => import("./Pages/Dashbaord/Employee/EmployeeOperations"),
);
const OnlineApplicants = lazy(
  () => import("./Pages/Dashbaord/Employee/OnlineApplicants"),
);
const InterviewCheckList = lazy(
  () => import("./Pages/Dashbaord/Employee/InterviewCheckList"),
);
const EmployeeInfo = lazy(
  () => import("./Pages/Dashbaord/Employee/EmployeeInfo"),
);
const AddEmployee = lazy(
  () => import("./Pages/Dashbaord/Employee/AddEmployee"),
);
const EditBasicInfoEmployee = lazy(
  () => import("./Pages/Dashbaord/Employee/EditBasicInfoEmployee"),
);
const EditPayrollInfoEmployee = lazy(
  () => import("./Pages/Dashbaord/Employee/EditPayrollInfoEmployee"),
);
const EditAddressEmployee = lazy(
  () => import("./Pages/Dashbaord/Employee/EditAddressEmployee"),
);
const EditQualificationEmployee = lazy(
  () => import("./Pages/Dashbaord/Employee/EditQualificationEmployee"),
);
const EditTrainingHistoryEmployee = lazy(
  () => import("./Pages/Dashbaord/Employee/EditTrainingHistoryEmployee"),
);
const EditSiaQuestionsEmployee = lazy(
  () => import("./Pages/Dashbaord/Employee/EditSiaQuestionsEmployee"),
);
const EditReferencesEmployee = lazy(
  () => import("./Pages/Dashbaord/Employee/EditReferencesEmployee"),
);
const EditHealthEmployee = lazy(
  () => import("./Pages/Dashbaord/Employee/EditHealthEmployee"),
);
const EditGdprNoticeEmployee = lazy(
  () => import("./Pages/Dashbaord/Employee/EditGdprNoticeEmployee"),
);
const EditDeclarationEmployee = lazy(
  () => import("./Pages/Dashbaord/Employee/EditDeclarationEmployee"),
);
const EditUniformEmployee = lazy(
  () => import("./Pages/Dashbaord/Employee/EditUniformEmployee"),
);
const EditJobContractEmployee = lazy(
  () => import("./Pages/Dashbaord/Employee/EditJobContractEmployee"),
);
const EmployeeTrash = lazy(
  () => import("./Pages/Dashbaord/Employee/EmployeeTrash"),
);
const GuardGroup = lazy(() => import("./Pages/Dashbaord/Employee/GuardGroup"));
const GuardGroupAssignStaff = lazy(
  () => import("./Pages/Dashbaord/Employee/GuardGroupAssignStaff"),
);
const EmployeeHolidaysDetails = lazy(
  () => import("./Pages/Dashbaord/Employee/EmployeeHolidaysDetails"),
);
const EmployeeHolidayRequests = lazy(
  () => import("./Pages/Dashbaord/Employee/EmployeeHolidayRequests"),
);
const EmployeeHolidayCalander = lazy(
  () => import("./Pages/Dashbaord/Employee/EmployeeHolidayCalander"),
);
const AddSubcontractor = lazy(
  () => import("./Pages/Dashbaord/Subcontractor/AddSubcontractor"),
);
const Subcontractors = lazy(
  () => import("./Pages/Dashbaord/Subcontractor/Subcontractors"),
);
const SubcontractorDetail = lazy(
  () => import("./Pages/Dashbaord/Subcontractor/SubcontractorDetail"),
);
const SubcontractorInvoicesAdmin = lazy(
  () => import("./Pages/Dashbaord/Subcontractor/SubcontractorInvoices"),
);
const InvoiceSubcontractors = lazy(
  () => import("./Pages/Dashbaord/Invoices/InvoiceSubcontractors"),
);
const SubcontractorDashboard = lazy(
  () => import("./Pages/SubContractorPanel/SubcontractorDashboard"),
);
const SubcontractorsTrash = lazy(
  () => import("./Pages/Dashbaord/Subcontractor/SubcontractorsTrash"),
);
const Clients = lazy(() => import("./Pages/Dashbaord/Client/Clients"));
const AddClient = lazy(() => import("./Pages/Dashbaord/Client/AddClient"));
const ClientsTrash = lazy(
  () => import("./Pages/Dashbaord/Client/ClientsTrash"),
);
const ClientDetail = lazy(
  () => import("./Pages/Dashbaord/Client/ClientDetail"),
);
const Sites = lazy(() => import("./Pages/Dashbaord/Sites/Sites"));
const AddSite = lazy(() => import("./Pages/Dashbaord/Sites/AddSite"));
const SitesTrash = lazy(() => import("./Pages/Dashbaord/Sites/SitesTrash"));
const SiteDetail = lazy(() => import("./Pages/Dashbaord/Sites/SiteDetail"));
const ClientRoster = lazy(
  () => import("./Pages/Dashbaord/Roster/ClientRoster"),
);
const ClientRosterSubcontractorDashboard = lazy(
  () => import("./Pages/Dashbaord/Roster/ClientRosterSubcontractorDashboard"),
);
const AddRoster = lazy(() => import("./Pages/Dashbaord/Roster/AddRoster"));
const AddMultipleRoster = lazy(
  () => import("./Pages/Dashbaord/Roster/AddMultipleRoster"),
);
const EmployeeRoster = lazy(
  () => import("./Pages/Dashbaord/Roster/EmployeeRoster"),
);
const SubcontractorRoster = lazy(
  () => import("./Pages/Dashbaord/Roster/SubcontractorRoster"),
);
const SiteCard = lazy(() => import("./Pages/Dashbaord/Roster/SiteCard"));
const AssignStaffRoster = lazy(
  () => import("./Pages/Dashbaord/Roster/AssignStaffRoster"),
);
const MultipleEditRoster = lazy(
  () => import("./Pages/Dashbaord/Roster/MultipleEditRoster"),
);
const EditClientRoster = lazy(
  () => import("./Pages/Dashbaord/Roster/EditClientRoster"),
);
const EditEmployeeRoster = lazy(
  () => import("./Pages/Dashbaord/Roster/EditEmployeeRoster"),
);
const EditSubcontractorRoster = lazy(
  () => import("./Pages/Dashbaord/Roster/EditSubcontractorRoster"),
);
const Events = lazy(() => import("./Pages/Dashbaord/Events"));
const Callout = lazy(() => import("./Pages/Dashbaord/Callout"));
const CallMoniter = lazy(
  () => import("./Pages/Dashbaord/CallMoniter/CallMoniter"),
);
const Reports = lazy(() => import("./Pages/Dashbaord/Reports/Reports"));
const Permissions = lazy(
  () => import("./Pages/Dashbaord/permissions/permissions"),
);
const PermissionView = lazy(
  () => import("./Pages/Dashbaord/permissions/PermissionView"),
);
const PermissionEdit = lazy(
  () => import("./Pages/Dashbaord/permissions/PermissionEdit"),
);
const PermissionAdd = lazy(
  () => import("./Pages/Dashbaord/permissions/PermissionAdd"),
);
const EditRoster = lazy(() => import("./Pages/Dashbaord/Roster/EditRoster"));
const EditRosterSubcontractorDashboard = lazy(
  () => import("./Pages/Dashbaord/Roster/EditRosterSubcontractorDashboard"),
);
const SubcontractorInvoices = lazy(
  () => import("./Pages/SubContractorPanel/SubcontractorInvoices"),
);
const Incidents = lazy(() => import("./Pages/Dashbaord/Incidents/Incidents"));
const IncidentDetail = lazy(
  () => import("./Pages/Dashbaord/Incidents/IncidentDetail"),
);

const AppRoutes = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route path="/pdfjson" element={<PdfJson />} />
        <Route path="*" element={<UnderConstruction />} />
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route exact path="/online-apply/login" element={<ApplyOnline />} />

        <Route path="/online-apply" element={<ApplyOnlineLayout />}>
          <Route path="form-1" element={<Form1Form />} />
          <Route path="form-2" element={<Form2Form />} />
          <Route path="form-3" element={<Form3Form />} />
          <Route path="form-4" element={<Form4Form />} />
          <Route path="form-9" element={<Form9Form />} />
          <Route path="form-10" element={<Form10Form />} />
          <Route path="form-11" element={<Form11Form />} />
          <Route path="upload-documents" element={<UploadDocumentsForm />} />
          <Route path="gdpr-notice" element={<GdprNoticeForm />} />
          <Route path="finish" element={<FinishForm />} />
        </Route>
        <Route
          path="/online-apply-subcontractor"
          element={<ApplySubcontractor />}
        />
        <Route path="/fiveyearsmatrix/:id" element={<EmployeeMatrixPage />} />

        <Route path="/" element={<DashboardLayout />}>
          <Route index element={<DashboardHome />} />
          <Route path="/home" element={<DashboardHome />} />
          <Route path="/emp/op" element={<EmployeeOperations />} />
          <Route path="/emp/online-applicants" element={<OnlineApplicants />} />
          <Route
            path="/employees/documents/:id"
            element={<EmployeeDocumentView />}
          />
          <Route
            path="/emp/op/app-form/:id/interview-checklist"
            element={<InterviewCheckList />}
          />
          <Route path="/emp/op/view/:id" element={<EmployeeInfo />} />
          <Route path="/emp/add" element={<AddEmployee />} />
          <Route
            path="/emp/op/app-form/:id/basic"
            element={<EditBasicInfoEmployee />}
          />
          <Route
            path="/emp/op/app-form/:id/payroll"
            element={<EditPayrollInfoEmployee />}
          />
          <Route
            path="/emp/op/app-form/:id/addresses"
            element={<EditAddressEmployee />}
          />
          <Route
            path="/emp/op/app-form/:id/qualification"
            element={<EditQualificationEmployee />}
          />
          <Route
            path="/emp/op/app-form/:id/previous-history"
            element={<EditTrainingHistoryEmployee />}
          />
          <Route
            path="/emp/op/app-form/:id/documents"
            element={<EmployeeDocument />}
          />
          <Route
            path="/emp/op/app-form/:id/siaQuestions"
            element={<EditSiaQuestionsEmployee />}
          />
          <Route
            path="/emp/op/app-form/:id/health"
            element={<EditHealthEmployee />}
          />
          <Route
            path="/emp/op/app-form/:id/references"
            element={<EditReferencesEmployee />}
          />
          <Route
            path="/emp/op/app-form/:id/gdpr-notice"
            element={<EditGdprNoticeEmployee />}
          />
          <Route
            path="/emp/op/app-form/:id/declaration"
            element={<EditDeclarationEmployee />}
          />
          <Route
            path="/emp/op/app-form/:id/uniform"
            element={<EditUniformEmployee />}
          />
          <Route
            path="/emp/op/app-form/:id/job-contract"
            element={<EditJobContractEmployee />}
          />
          <Route path="/emp/trash/op" element={<EmployeeTrash />} />
          <Route path="/emp/trash/view/:id" element={<EmployeeInfo />} />
          <Route path="/emp/guard/groups" element={<GuardGroup />} />
          <Route
            path="/emp/guard/groups/assign-staff/:id"
            element={<GuardGroupAssignStaff />}
          />
          <Route
            path="/emp/holiday/empwise"
            element={<EmployeeHolidaysDetails />}
          />
          <Route
            path="/emp/holiday/requests"
            element={<EmployeeHolidayRequests />}
          />
          <Route
            path="/emp/holiday/calendar"
            element={<EmployeeHolidayCalander />}
          />
          <Route path="/sub/add" element={<AddSubcontractor />} />
          <Route path="/sub" element={<Subcontractors />} />
          <Route path="/sub/:id/detail" element={<SubcontractorDetail />} />
          <Route
            path="/sub/invoices/:id"
            element={<SubcontractorInvoicesAdmin />}
          />
          <Route path="/invoices/sub/" element={<InvoiceSubcontractors />} />
          <Route
            path="/subcontractorDashboard/:id/detail"
            element={<SubcontractorDashboard />}
          />
          <Route path="/sub/trash" element={<SubcontractorsTrash />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/client/add" element={<AddClient />} />
          <Route path="/clients/trash" element={<ClientsTrash />} />
          <Route path="/client/:id/detail" element={<ClientDetail />} />
          <Route path="/sites" element={<Sites />} />
          <Route path="/site/add" element={<AddSite />} />
          <Route path="/sites/trash" element={<SitesTrash />} />
          <Route path="/site/:id/detail" element={<SiteDetail />} />
          <Route path="/c-roster" element={<ClientRoster />} />
          <Route
            path="/c-roster-subcontractor"
            element={<ClientRosterSubcontractorDashboard />}
          />
          <Route path="/e-roster" element={<EmployeeRoster />} />
          <Route path="/roster/add" element={<AddRoster />} />
          <Route
            path="/roster/add/multiple-g"
            element={<AddMultipleRoster />}
          />
          <Route path="/s-roster" element={<SubcontractorRoster />} />
          <Route path="/load-site-roster" element={<SiteCard />} />
          <Route path="/assign-staffs-roster" element={<AssignStaffRoster />} />
          <Route path="/me-roster" element={<MultipleEditRoster />} />
          <Route
            path="/roster/edit-client-roster/client-view"
            element={<EditClientRoster />}
          />
          <Route
            path="/roster/emp-roster/edit-new"
            element={<EditEmployeeRoster />}
          />
          <Route
            path="/roster/edit-sub-staff-roster"
            element={<EditSubcontractorRoster />}
          />
          <Route path="/events" element={<Events />} />
          <Route path="/callout" element={<Callout />} />
          <Route path="/call-monitor" element={<CallMoniter />} />
          <Route path="/reports/view" element={<Reports />} />
          <Route path="/permissions" element={<Permissions />} />
          <Route path="/permissions/view/:id" element={<PermissionView />} />
          <Route path="/permissions/edit/:id" element={<PermissionEdit />} />
          <Route path="/permissions/add" element={<PermissionAdd />} />

          <Route path="/edit-roster/:id" element={<EditRoster />} />
          <Route
            path="/edit-roster-subcontractor/:id"
            element={<EditRosterSubcontractorDashboard />}
          />
          <Route path="/invoices/:id" element={<SubcontractorInvoices />} />
          <Route path="/incidents" element={<Incidents />} />
          <Route path="/incident-detail" element={<IncidentDetail />} />
        </Route>
        <Route path="/excel" element={<Excel />} />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
